import * as XLSX from "xlsx-js-style";

var SECTION_INTRALABORAL = "intralaboral";
var SECTION_EXTRALABORAL = "extralaboral";
var SECTION_TOTAL_GENERAL = "total";
var SECTION_STRESS = "estres";

export var FORM_A_CATALOG = [
  { code: "clidert", name: "Características del liderazgo" },
  { code: "relsoct", name: "Relaciones sociales en el trabajo" },
  { code: "retrot", name: "Retroalimentación del desempeño" },
  { code: "relcolt", name: "Relación con los colaboradores" },
  {
    code: "LIDt",
    name: "Liderazgo y relaciones sociales en el trabajo",
  },
  { code: "clrolt", name: "Claridad de rol" },
  { code: "capact", name: "Capacitación" },
  { code: "partict", name: "Participación y manejo del cambio" },
  {
    code: "oportt",
    name:
      "Oportunidades para el uso y desarrollo de habilidades y conocimientos",
  },
  { code: "contrt", name: "Control y autonomía sobre el trabajo" },
  { code: "CONTROL", name: "Control sobre el trabajo" },
  {
    code: "demfist",
    name: "Demandas ambientales y de esfuerzo físico",
  },
  { code: "dememot", name: "Demandas emocionales" },
  { code: "demcuantit", name: "Demandas cuantitativas" },
  {
    code: "inftrabt",
    name: "Influencia del trabajo sobre el entorno extralaboral",
  },
  { code: "exigent", name: "Exigencias de responsabilidad del cargo" },
  { code: "cmentalt", name: "Demandas de carga mental" },
  { code: "consist", name: "Consistencia del rol" },
  { code: "jornadat", name: "Demandas de la jornada de trabajo" },
  { code: "DEMANDAt", name: "Demandas del trabajo" },
  {
    code: "recompt",
    name:
      "Recompensas derivadas de la pertenencia a la organización y del trabajo que se realiza",
  },
  { code: "reconot", name: "Reconocimiento y compensación" },
  { code: "RECOMPENSAt", name: "Recompensas" },
  { code: "TOTALINTRAt", name: "Total intralaboral" },

  { code: "tftAt", name: "Tiempo fuera del trabajo", section: SECTION_EXTRALABORAL },
  { code: "relfaAt", name: "Relaciones familiares", section: SECTION_EXTRALABORAL },
  {
    code: "comuAt",
    name: "Comunicación y relaciones interpersonales",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "sitecoAt",
    name: "Situación económica del grupo familiar",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "cvivAt",
    name: "Características de la vivienda y de su entorno",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "influexAt",
    name: "Influencia del entorno extralaboral sobre el trabajo",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "desplaAt",
    name: "Desplazamiento vivienda - trabajo - vivienda",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "TOTALEXTRA_At",
    name: "Total extralaboral",
    section: SECTION_EXTRALABORAL,
  },

  {
    code: "TOTALFRPat",
    name: "Total general FRP",
    section: SECTION_TOTAL_GENERAL,
  },

  {
    code: "ESTRESt_A",
    sourceCode: "ESTRESt",
    name: "Estrés",
    section: SECTION_STRESS,
  },
];

export var FORM_B_CATALOG = [
  { code: "cliderbt", name: "Características del liderazgo" },
  { code: "relsocbt", name: "Relaciones sociales en el trabajo" },
  { code: "retrobt", name: "Retroalimentación del desempeño" },
  {
    code: "LIDbt",
    name: "Liderazgo y relaciones sociales en el trabajo",
  },
  { code: "clrolbt", name: "Claridad de rol" },
  { code: "capacbt", name: "Capacitación" },
  { code: "particbt", name: "Participación y manejo del cambio" },
  {
    code: "oportbt",
    name:
      "Oportunidades para el uso y desarrollo de habilidades y conocimientos",
  },
  { code: "contrbt", name: "Control y autonomía sobre el trabajo" },
  { code: "CONTROLBt", name: "Control sobre el trabajo" },
  {
    code: "demfisbt",
    name: "Demandas ambientales y de esfuerzo físico",
  },
  {
    code: "dememobt",
    aliases: ["demomobt"],
    name: "Demandas emocionales",
  },
  { code: "demcuantibt", name: "Demandas cuantitativas" },
  {
    code: "inftrabbt",
    name: "Influencia del trabajo sobre el entorno extralaboral",
  },
  { code: "cmentalbt", name: "Demandas de carga mental" },
  { code: "jornadabt", name: "Demandas de la jornada de trabajo" },
  { code: "DEMANDABt", name: "Demandas del trabajo" },
  {
    code: "recompbt",
    name:
      "Recompensas derivadas de la pertenencia a la organización y del trabajo que se realiza",
  },
  { code: "reconob", name: "Reconocimiento y compensación" },
  { code: "RECOMPENSABt", name: "Recompensas" },
  { code: "TOTALINTRAbt", name: "Total intralaboral" },

  { code: "tftBt", name: "Tiempo fuera del trabajo", section: SECTION_EXTRALABORAL },
  { code: "relfaBt", name: "Relaciones familiares", section: SECTION_EXTRALABORAL },
  {
    code: "comuBt",
    name: "Comunicación y relaciones interpersonales",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "sitecoBt",
    name: "Situación económica del grupo familiar",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "cvivBt",
    name: "Características de la vivienda y de su entorno",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "influexBt",
    name: "Influencia del entorno extralaboral sobre el trabajo",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "desplaBt",
    name: "Desplazamiento vivienda - trabajo - vivienda",
    section: SECTION_EXTRALABORAL,
  },
  {
    code: "TOTALEXTRA_Bt",
    name: "Total extralaboral",
    section: SECTION_EXTRALABORAL,
  },

  {
    code: "TOTALFRPbt",
    name: "Total general FRP",
    section: SECTION_TOTAL_GENERAL,
  },

  {
    code: "ESTRESt_B",
    sourceCode: "ESTRESt",
    name: "Estrés",
    section: SECTION_STRESS,
  },
];

export var TRANSFORMED_SCORE_TEMPLATE_COLUMNS = [
  "clidert",
  "relsoct",
  "retrot",
  "relcolt",
  "LIDt",
  "clrolt",
  "capact",
  "partict",
  "contrt",
  "oportt",
  "CONTROL",
  "demfist",
  "dememot",
  "demcuantit",
  "inftrabt",
  "exigent",
  "cmentalt",
  "consist",
  "jornadat",
  "DEMANDAt",
  "recompt",
  "reconot",
  "RECOMPENSAt",
  "TOTALINTRAt",
  "cliderbt",
  "relsocbt",
  "retrobt",
  "LIDbt",
  "clrolbt",
  "capacbt",
  "particbt",
  "oportbt",
  "contrbt",
  "CONTROLBt",
  "demfisbt",
  "demomobt",
  "demcuantibt",
  "inftrabbt",
  "cmentalbt",
  "jornadabt",
  "DEMANDABt",
  "recompbt",
  "reconob",
  "RECOMPENSABt",
  "TOTALINTRABt",
  "tftAt",
  "relfaAt",
  "tftBt",
  "relfaBt",
  "comuAt",
  "comuBt",
  "sitecoAt",
  "sitecoBt",
  "cvivAt",
  "cvivBt",
  "influexAt",
  "influexBt",
  "desplaAt",
  "desplaBt",
  "TOTALEXTRA_At",
  "TOTALEXTRA_Bt",
  "TOTALFRPat",
  "TOTALFRPbt",
  "ESTRESt",
];

function rangesFromCutoffs(cutoffs) {
  var c1 = cutoffs[0];
  var c2 = cutoffs[1];
  var c3 = cutoffs[2];
  var c4 = cutoffs[3];

  return [
    { level: "noRisk", min: 0, max: c1 },
    { level: "low", min: round1(c1 + 0.1), max: c2 },
    { level: "medium", min: round1(c2 + 0.1), max: c3 },
    { level: "high", min: round1(c3 + 0.1), max: c4 },
    { level: "veryHigh", min: round1(c4 + 0.1), max: 100 },
  ];
}

export function round1(value) {
  return Math.round((value + Number.EPSILON) * 10) / 10;
}

export var FORM_A_RANGES = {
  "Características del liderazgo": rangesFromCutoffs([3.8, 15.4, 30.8, 46.2]),
  "Relaciones sociales en el trabajo": rangesFromCutoffs([
    5.4,
    16.1,
    25.0,
    37.5,
  ]),
  "Retroalimentación del desempeño": rangesFromCutoffs([
    10.0,
    25.0,
    40.0,
    55.0,
  ]),
  "Relación con los colaboradores": rangesFromCutoffs([
    13.9,
    25.0,
    33.3,
    47.2,
  ]),
  "Claridad de rol": rangesFromCutoffs([0.9, 10.7, 21.4, 39.3]),
  Capacitación: rangesFromCutoffs([0.9, 16.7, 33.3, 50.0]),
  "Participación y manejo del cambio": rangesFromCutoffs([
    12.5,
    25.0,
    37.5,
    50.0,
  ]),
  "Oportunidades para el uso y desarrollo de habilidades y conocimientos": rangesFromCutoffs(
    [0.9, 6.3, 18.8, 31.3]
  ),
  "Control y autonomía sobre el trabajo": rangesFromCutoffs([
    8.3,
    25.0,
    41.7,
    58.3,
  ]),
  "Demandas ambientales y de esfuerzo físico": rangesFromCutoffs([
    14.6,
    22.9,
    31.3,
    39.6,
  ]),
  "Demandas emocionales": rangesFromCutoffs([16.7, 25.0, 33.3, 47.2]),
  "Demandas cuantitativas": rangesFromCutoffs([25.0, 33.3, 45.8, 54.2]),
  "Influencia del trabajo sobre el entorno extralaboral": rangesFromCutoffs([
    18.8,
    31.3,
    43.8,
    50.0,
  ]),
  "Exigencias de responsabilidad del cargo": rangesFromCutoffs([
    37.5,
    54.2,
    66.7,
    79.2,
  ]),
  "Demandas de carga mental": rangesFromCutoffs([60.0, 70.0, 80.0, 90.0]),
  "Consistencia del rol": rangesFromCutoffs([15.0, 25.0, 35.0, 45.0]),
  "Demandas de la jornada de trabajo": rangesFromCutoffs([
    8.3,
    25.0,
    33.3,
    50.0,
  ]),
  "Recompensas derivadas de la pertenencia a la organización y del trabajo que se realiza": rangesFromCutoffs(
    [0.9, 5.0, 10.0, 20.0]
  ),
  "Reconocimiento y compensación": rangesFromCutoffs([4.2, 16.7, 25.0, 37.5]),
  "Liderazgo y relaciones sociales en el trabajo": rangesFromCutoffs([
    9.1,
    17.7,
    25.6,
    34.8,
  ]),
  "Control sobre el trabajo": rangesFromCutoffs([10.7, 19.0, 29.8, 40.5]),
  "Demandas del trabajo": rangesFromCutoffs([28.5, 35.0, 41.5, 47.5]),
  Recompensas: rangesFromCutoffs([4.5, 11.4, 20.5, 29.5]),
  "Total intralaboral": rangesFromCutoffs([19.7, 25.8, 31.5, 38.0]),

  "Tiempo fuera del trabajo": rangesFromCutoffs([
    6.3,
    25.0,
    37.5,
    50.0,
  ]),
  "Relaciones familiares": rangesFromCutoffs([8.3, 25.0, 33.3, 50.0]),
  "Comunicación y relaciones interpersonales": rangesFromCutoffs([
    0.9,
    10.0,
    20.0,
    30.0,
  ]),
  "Situación económica del grupo familiar": rangesFromCutoffs([
    8.3,
    25.0,
    33.3,
    50.0,
  ]),
  "Características de la vivienda y de su entorno": rangesFromCutoffs([
    5.6,
    11.1,
    13.9,
    22.2,
  ]),
  "Influencia del entorno extralaboral sobre el trabajo": rangesFromCutoffs([
    8.3,
    16.7,
    25.0,
    41.7,
  ]),
  "Desplazamiento vivienda - trabajo - vivienda": rangesFromCutoffs([
    0.9,
    12.5,
    25.0,
    43.8,
  ]),
  "Total extralaboral": rangesFromCutoffs([11.3, 16.9, 22.6, 29.0]),

  "Total general FRP": rangesFromCutoffs([18.8, 24.4, 29.5, 35.4]),

  Estrés: rangesFromCutoffs([7.8, 12.6, 17.7, 25.0]),
};

export var FORM_B_RANGES = {
  "Características del liderazgo": rangesFromCutoffs([3.8, 13.5, 25.0, 38.5]),
  "Relaciones sociales en el trabajo": rangesFromCutoffs([
    6.3,
    14.6,
    27.1,
    37.5,
  ]),
  "Retroalimentación del desempeño": rangesFromCutoffs([
    5.0,
    20.0,
    30.0,
    50.0,
  ]),
  "Claridad de rol": rangesFromCutoffs([0.9, 5.0, 15.0, 30.0]),
  Capacitación: rangesFromCutoffs([0.9, 16.7, 25.0, 50.0]),
  "Participación y manejo del cambio": rangesFromCutoffs([
    16.7,
    33.3,
    41.7,
    58.3,
  ]),
  "Oportunidades para el uso y desarrollo de habilidades y conocimientos": rangesFromCutoffs(
    [12.5, 25.0, 37.5, 56.3]
  ),
  "Control y autonomía sobre el trabajo": rangesFromCutoffs([
    33.3,
    50.0,
    66.7,
    75.0,
  ]),
  "Demandas ambientales y de esfuerzo físico": rangesFromCutoffs([
    22.9,
    31.3,
    39.6,
    47.9,
  ]),
  "Demandas emocionales": rangesFromCutoffs([19.4, 27.8, 38.9, 47.2]),
  "Demandas cuantitativas": rangesFromCutoffs([16.7, 33.3, 41.7, 50.0]),
  "Influencia del trabajo sobre el entorno extralaboral": rangesFromCutoffs([
    12.5,
    25.0,
    31.3,
    50.0,
  ]),
  "Demandas de carga mental": rangesFromCutoffs([50.0, 65.0, 75.0, 85.0]),
  "Demandas de la jornada de trabajo": rangesFromCutoffs([
    25.0,
    37.5,
    45.8,
    58.3,
  ]),
  "Recompensas derivadas de la pertenencia a la organización y del trabajo que se realiza": rangesFromCutoffs(
    [0.9, 6.3, 12.5, 18.8]
  ),
  "Reconocimiento y compensación": rangesFromCutoffs([0.9, 12.5, 25.0, 37.5]),
  "Liderazgo y relaciones sociales en el trabajo": rangesFromCutoffs([
    8.3,
    17.5,
    26.7,
    38.3,
  ]),
  "Control sobre el trabajo": rangesFromCutoffs([19.4, 26.4, 34.7, 43.1]),
  "Demandas del trabajo": rangesFromCutoffs([26.9, 33.3, 37.8, 44.2]),
  Recompensas: rangesFromCutoffs([2.5, 10.0, 17.5, 27.5]),
  "Total intralaboral": rangesFromCutoffs([20.6, 26.0, 31.2, 38.7]),

  "Tiempo fuera del trabajo": rangesFromCutoffs([
    6.3,
    25.0,
    37.5,
    50.0,
  ]),
  "Relaciones familiares": rangesFromCutoffs([8.3, 25.0, 33.3, 50.0]),
  "Comunicación y relaciones interpersonales": rangesFromCutoffs([
    5.0,
    15.0,
    25.0,
    35.0,
  ]),
  "Situación económica del grupo familiar": rangesFromCutoffs([
    16.7,
    25.0,
    41.7,
    50.0,
  ]),
  "Características de la vivienda y de su entorno": rangesFromCutoffs([
    5.6,
    11.1,
    16.7,
    27.8,
  ]),
  "Influencia del entorno extralaboral sobre el trabajo": rangesFromCutoffs([
    0.9,
    16.7,
    25.0,
    41.7,
  ]),
  "Desplazamiento vivienda - trabajo - vivienda": rangesFromCutoffs([
    0.9,
    12.5,
    25.0,
    43.8,
  ]),
  "Total extralaboral": rangesFromCutoffs([12.9, 17.7, 24.2, 32.3]),

  "Total general FRP": rangesFromCutoffs([19.9, 24.8, 29.5, 35.4]),

  Estrés: rangesFromCutoffs([6.5, 11.8, 17.0, 23.4]),
};

export var RANGO_FP_PALETTE = {
  veryHigh: { background: "#f4cdcd", border: "#f6adad", text: "#8a2f2f" },
  high: { background: "#facca5", border: "#f6b884", text: "#8a4a1f" },
  medium: { background: "#fff2cc", border: "#f6db8a", text: "#7a6a1f" },
  low: { background: "#d9ead3", border: "#c3eab5", text: "#2f6b3f" },
  noRisk: { background: "#c8d9f7", border: "#a8c2ef", text: "#2f4f8a" },
};

var GROUPING_PREFIX = "AGR-";
var FORM_COLUMN = "AGR-FORMA";
var YEAR_COLUMN = "AGR-year";
var MIN_VALID_RESPONDENTS = 5;

function findHeaderCaseInsensitive(headers, target) {
  var lowerTarget = target.toLowerCase();

  for (var i = 0; i < headers.length; i++) {
    if (
      typeof headers[i] === "string" &&
      headers[i].toLowerCase() === lowerTarget
    ) {
      return headers[i];
    }
  }

  return null;
}

function resolveEntryHeader(headers, entry) {
  var candidates = [entry.sourceCode || entry.code].concat(
    entry.aliases || []
  );

  for (var i = 0; i < candidates.length; i++) {
    var header = findHeaderCaseInsensitive(headers, candidates[i]);

    if (header) {
      return header;
    }
  }

  return null;
}

function getRowForm(row, formHeader) {
  var value = formHeader ? row[formHeader] : undefined;

  if (value === undefined || value === null) {
    return null;
  }

  var normalized = String(value).trim().toUpperCase();

  return normalized === "A" || normalized === "B" ? normalized : null;
}

function getCombinedCatalog() {
  var combined = [];

  FORM_A_CATALOG.forEach(function (entry) {
    combined.push({
      code: entry.code,
      sourceCode: entry.sourceCode,
      aliases: entry.aliases,
      name: entry.name,
      section: entry.section || SECTION_INTRALABORAL,
      form: "A",
    });
  });

  FORM_B_CATALOG.forEach(function (entry) {
    combined.push({
      code: entry.code,
      sourceCode: entry.sourceCode,
      aliases: entry.aliases,
      name: entry.name,
      section: entry.section || SECTION_INTRALABORAL,
      form: "B",
    });
  });

  return combined;
}

export function parseRows(headers, dataRows) {
  return dataRows.map(function (row) {
    var obj = {};

    headers.forEach(function (header, index) {
      obj[header] = row[index];
    });

    return obj;
  });
}

export function detectCatalogColumns(headers) {
  var catalog = getCombinedCatalog();

  return catalog
    .map(function (entry) {
      return {
        code: entry.code,
        name: entry.name,
        section: entry.section,
        form: entry.form,
        header: resolveEntryHeader(headers, entry),
      };
    })
    .filter(function (entry) {
      return entry.header !== null;
    });
}

export function detectGroupingColumns(headers) {
  var yearHeader = findHeaderCaseInsensitive(headers, YEAR_COLUMN);

  return headers.filter(function (header) {
    if (typeof header !== "string" || header.indexOf(GROUPING_PREFIX) !== 0) {
      return false;
    }

    return header !== yearHeader;
  });
}

export function filterColumnsWithData(catalog, combinations) {
  return catalog.filter(function (entry) {
    return combinations.some(function (combination) {
      var value = combination.averages[entry.code];

      return value !== null && value !== undefined;
    });
  });
}

function isValidNumericValue(value) {
  if (value === undefined || value === null || value === "") {
    return false;
  }

  var number = Number(value);

  return !isNaN(number) && isFinite(number);
}

function filterRowsByLatestYear(headers, rows) {
  var yearHeader = findHeaderCaseInsensitive(headers, YEAR_COLUMN);

  if (!yearHeader) {
    return rows;
  }

  var maxYear = null;

  rows.forEach(function (row) {
    var year = parseInt(row[yearHeader], 10);

    if (!isNaN(year) && (maxYear === null || year > maxYear)) {
      maxYear = year;
    }
  });

  if (maxYear === null) {
    return rows;
  }

  return rows.filter(function (row) {
    return parseInt(row[yearHeader], 10) === maxYear;
  });
}

export function calculateAveragesByForm(headers, dataRows) {
  var formHeader = findHeaderCaseInsensitive(headers, FORM_COLUMN);
  var rows = filterRowsByLatestYear(headers, parseRows(headers, dataRows));
  var groupingColumns = detectGroupingColumns(headers);
  var catalog = detectCatalogColumns(headers);
  var accumulators = {};
  var order = [];

  rows.forEach(function (row) {
    var rowForm = getRowForm(row, formHeader);

    groupingColumns.forEach(function (groupColumn) {
      var group = groupColumn.substring(GROUPING_PREFIX.length);
      var subgroupRaw = row[groupColumn];
      var subgroup =
        subgroupRaw === undefined || subgroupRaw === null
          ? ""
          : String(subgroupRaw).trim();

      if (!subgroup) {
        return;
      }

      var key = group + " = " + subgroup;

      if (!accumulators[key]) {
        accumulators[key] = {
          group: group,
          subgroup: subgroup,
          sums: {},
          formCounts: { A: 0, B: 0 },
        };
        order.push(key);
      }

      if (rowForm === "A" || rowForm === "B") {
        accumulators[key].formCounts[rowForm] += 1;
      }

      catalog.forEach(function (entry) {
        if (entry.form !== rowForm) {
          return;
        }

        var cellValue = row[entry.header];

        if (!isValidNumericValue(cellValue)) {
          return;
        }

        if (!accumulators[key].sums[entry.code]) {
          accumulators[key].sums[entry.code] = { sum: 0, count: 0 };
        }

        accumulators[key].sums[entry.code].sum += Number(cellValue);
        accumulators[key].sums[entry.code].count += 1;
      });
    });
  });

  var combinations = [];
  var excluded = [];

  order.forEach(function (key) {
    var accumulator = accumulators[key];
    var averages = {};
    var hasAnyData = false;

    catalog.forEach(function (entry) {
      var variableAccumulator = accumulator.sums[entry.code];
      var meetsMinimum =
        accumulator.formCounts[entry.form] >= MIN_VALID_RESPONDENTS;

      if (meetsMinimum && variableAccumulator && variableAccumulator.count > 0) {
        averages[entry.code] =
          variableAccumulator.sum / variableAccumulator.count;
        hasAnyData = true;
      } else {
        averages[entry.code] = null;
      }
    });

    if (hasAnyData) {
      combinations.push({
        group: accumulator.group,
        subgroup: accumulator.subgroup,
        averages: averages,
        formCounts: accumulator.formCounts,
      });
    } else {
      excluded.push(key);
    }
  });

  return { combinations: combinations, excluded: excluded };
}

export function classifyValue(value, variableName, form) {
  var rangeTable = form === "B" ? FORM_B_RANGES : FORM_A_RANGES;
  var ranges = rangeTable[variableName];

  if (!ranges) {
    return null;
  }

  var roundedValue = round1(value);
  var foundLevel = null;

  ranges.forEach(function (range) {
    if (roundedValue >= range.min && roundedValue <= range.max) {
      foundLevel = range.level;
    }
  });

  return foundLevel;
}

function applyCellStyle(sheet, rowIndex, colIndex, level) {
  var colors = RANGO_FP_PALETTE[level];
  var cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
  var cell = sheet[cellAddress];

  if (!cell) {
    return;
  }

  cell.s = {
    fill: {
      patternType: "solid",
      fgColor: { rgb: colors.background.replace("#", "") },
    },
    border: {
      top: { style: "thin", color: { rgb: colors.border.replace("#", "") } },
      bottom: {
        style: "thin",
        color: { rgb: colors.border.replace("#", "") },
      },
      left: { style: "thin", color: { rgb: colors.border.replace("#", "") } },
      right: {
        style: "thin",
        color: { rgb: colors.border.replace("#", "") },
      },
    },
    font: { color: { rgb: colors.text.replace("#", "") } },
  };
}

function buildFormSheet(result, formCatalog, form) {
  var visibleCatalog = filterColumnsWithData(
    formCatalog,
    result.combinations
  );
  var headers = ["Grupo", "SubGrupo", "N"].concat(
    visibleCatalog.map(function (entry) {
      return entry.name + " Forma " + form;
    })
  );
  var matrix = [headers];

  result.combinations.forEach(function (combination) {
    var row = [
      combination.group,
      combination.subgroup,
      combination.formCounts[form],
    ];

    visibleCatalog.forEach(function (entry) {
      var value = combination.averages[entry.code];

      row.push(value === null ? "" : round1(value));
    });

    matrix.push(row);
  });

  var sheet = XLSX.utils.aoa_to_sheet(matrix);

  result.combinations.forEach(function (combination, rowIndex) {
    visibleCatalog.forEach(function (entry, colIndex) {
      var value = combination.averages[entry.code];

      if (value === null) {
        return;
      }

      var level = classifyValue(value, entry.name, entry.form);

      if (!level) {
        return;
      }

      applyCellStyle(sheet, rowIndex + 1, colIndex + 3, level);
    });
  });

  return sheet;
}

function buildTotalGeneralSheet(result) {
  var catalog = getCombinedCatalog().filter(function (entry) {
    return entry.section === SECTION_TOTAL_GENERAL;
  });
  var entryA = catalog.filter(function (entry) {
    return entry.form === "A";
  })[0];
  var entryB = catalog.filter(function (entry) {
    return entry.form === "B";
  })[0];

  var headers = [
    "Grupo",
    "SubGrupo",
    "N Forma A",
    "N Forma B",
    entryA.name + " Forma A",
    entryB.name + " Forma B",
  ];
  var matrix = [headers];

  result.combinations.forEach(function (combination) {
    var valueA = combination.averages[entryA.code];
    var valueB = combination.averages[entryB.code];

    matrix.push([
      combination.group,
      combination.subgroup,
      combination.formCounts.A,
      combination.formCounts.B,
      valueA === null ? "" : round1(valueA),
      valueB === null ? "" : round1(valueB),
    ]);
  });

  var sheet = XLSX.utils.aoa_to_sheet(matrix);

  result.combinations.forEach(function (combination, rowIndex) {
    [
      { entry: entryA, colIndex: 4 },
      { entry: entryB, colIndex: 5 },
    ].forEach(function (item) {
      var value = combination.averages[item.entry.code];

      if (value === null) {
        return;
      }

      var level = classifyValue(value, item.entry.name, item.entry.form);

      if (!level) {
        return;
      }

      applyCellStyle(sheet, rowIndex + 1, item.colIndex, level);
    });
  });

  return sheet;
}

function buildStressSheet(result) {
  var catalog = getCombinedCatalog().filter(function (entry) {
    return entry.section === SECTION_STRESS;
  });
  var entryA = catalog.filter(function (entry) {
    return entry.form === "A";
  })[0];
  var entryB = catalog.filter(function (entry) {
    return entry.form === "B";
  })[0];

  var headers = [
    "Grupo",
    "SubGrupo",
    "N Forma A",
    "N Forma B",
    entryA.name + " Forma A",
    entryB.name + " Forma B",
  ];
  var matrix = [headers];

  result.combinations.forEach(function (combination) {
    var valueA = combination.averages[entryA.code];
    var valueB = combination.averages[entryB.code];

    matrix.push([
      combination.group,
      combination.subgroup,
      combination.formCounts.A,
      combination.formCounts.B,
      valueA === null ? "" : round1(valueA),
      valueB === null ? "" : round1(valueB),
    ]);
  });

  var sheet = XLSX.utils.aoa_to_sheet(matrix);

  result.combinations.forEach(function (combination, rowIndex) {
    [
      { entry: entryA, colIndex: 4 },
      { entry: entryB, colIndex: 5 },
    ].forEach(function (item) {
      var value = combination.averages[item.entry.code];

      if (value === null) {
        return;
      }

      var level = classifyValue(value, item.entry.name, item.entry.form);

      if (!level) {
        return;
      }

      applyCellStyle(sheet, rowIndex + 1, item.colIndex, level);
    });
  });

  return sheet;
}

export function buildWorkbook(result) {
  var catalog = getCombinedCatalog();

  function bySectionAndForm(section, form) {
    return catalog.filter(function (entry) {
      return entry.section === section && entry.form === form;
    });
  }

  var workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    buildFormSheet(result, bySectionAndForm(SECTION_INTRALABORAL, "A"), "A"),
    "Intralaboral A"
  );
  XLSX.utils.book_append_sheet(
    workbook,
    buildFormSheet(result, bySectionAndForm(SECTION_INTRALABORAL, "B"), "B"),
    "Intralaboral B"
  );
  XLSX.utils.book_append_sheet(
    workbook,
    buildFormSheet(result, bySectionAndForm(SECTION_EXTRALABORAL, "A"), "A"),
    "Extralaboral A"
  );
  XLSX.utils.book_append_sheet(
    workbook,
    buildFormSheet(result, bySectionAndForm(SECTION_EXTRALABORAL, "B"), "B"),
    "Extralaboral B"
  );
  XLSX.utils.book_append_sheet(
    workbook,
    buildTotalGeneralSheet(result),
    "Total General FRP"
  );
  XLSX.utils.book_append_sheet(workbook, buildStressSheet(result), "Estrés");

  return workbook;
}



// WEBPACK FOOTER //
// ./src/components/frpm/components/herramientas/promedios-forma/promedios-forma-helpers.js